import { DefaultValidations } from '../interfaces';

// Validações padrão aplicadas automaticamente por tipo de campo
export const DEFAULT_VALIDATIONS: DefaultValidations = {
    text: {
        maxLength: 255
    },
    email: {
        email: true,
        maxLength: 100
    },
    password: {
        minLength: 8,
        password: true
    },
    phone: {
        pattern: '^\\([0-9]{2}\\) [0-9]{4,5}-[0-9]{4}$'
    },
    cpf: {
        pattern: '^[0-9]{3}\\.[0-9]{3}\\.[0-9]{3}-[0-9]{2}$'
    },
    cnpj: {
        pattern: '^[0-9]{2}\\.[0-9]{3}\\.[0-9]{3}/[0-9]{4}-[0-9]{2}$'
    },
    cep: {
        pattern: '^[0-9]{5}-[0-9]{3}$'
    },
    number: {
        min: 0
    }
};

// Validações específicas para campos obrigatórios
export const REQUIRED_VALIDATIONS: DefaultValidations = {
    required: true
};

// Validações para campos de arquivo
export const FILE_VALIDATIONS: DefaultValidations = {
    maxSize: 5242880 // 5MB padrão
}; 